import { useRequest } from "../../../app/hooks/useRequest";
import { getAllRolesRequest, getRolesRequest } from "../RoleRequests";

export const useGetRoles = () => useRequest(getRolesRequest);
export const useGetAllRoles = () => useRequest(getAllRolesRequest);